import React, { useState } from 'react';
import { Step, StepList } from '../../../CommonComponents/OPL/Stepper';
import { ConfigureAccess, Props as ConfigureAccessProps } from '../ConfigureAccess/ConfigureAccess';
import { Tab, TabList } from '../../../CommonComponents/OPL/Tab';
import { ClientEmailInvitation } from './components/ClientEmailInvitation/ClientEmailInvitation';
import { ClientUrlInvitation } from './components/ClientUrlInvitation/ClientUrlInvitation';
import { StyledStepPanel, StyledSteps } from '../ConfigureAccess/ConfigureAccess.styles';
import { StyledTabPanel, StyledTabs } from './InviteClient.styles';

interface Props extends ConfigureAccessProps {}

export const InviteClient = (props: Props) => {
  const { clientId, onClose } = props;

  const [selectedStepIndex, setSelectedStepIndex] = useState(0);
  const [isInvitationComplete, setIsInvitationComplete] = useState(false);

  return (
    <StyledSteps
      selectedIndex={selectedStepIndex}
      onSelect={index => {
        setIsInvitationComplete(false);
        setSelectedStepIndex(index);
      }}
    >
      <StepList variant={isInvitationComplete ? 'complete' : undefined} mx="24" mt="8">
        {['Configure Access', 'Invite Client'].map((step, index) => (
          <Step disabled={selectedStepIndex < index}>{step}</Step>
        ))}
      </StepList>

      <StyledStepPanel>
        <ConfigureAccess
          {...props}
          onNext={() => setSelectedStepIndex(selectedStepIndex + 1)}
          isClientRegistered={false}
        />
      </StyledStepPanel>

      <StyledStepPanel>
        <StyledTabs>
          <TabList mx="24" mt="8">
            <Tab>Email</Tab>
            <Tab>URL</Tab>
          </TabList>

          {[ClientEmailInvitation, ClientUrlInvitation].map(InvitationComponent => (
            <StyledTabPanel>
              <InvitationComponent
                clientId={clientId}
                onClose={onClose}
                onSuccess={() => setIsInvitationComplete(true)}
                onBack={() => {
                  setSelectedStepIndex(0);
                  setIsInvitationComplete(false);
                }}
              />
            </StyledTabPanel>
          ))}
        </StyledTabs>
      </StyledStepPanel>
    </StyledSteps>
  );
};
